/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Session_OpenInputs */

const en_session_open = /** @type {(inputs: Session_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cook session ${i?.title}`)
};

const de_session_open = /** @type {(inputs: Session_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kochsession ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Cook session {title}" |
*
* @param {Session_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_open = /** @type {((inputs: Session_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_open(inputs)
	return en_session_open(inputs)
});